import { createSlice, PayloadAction } from '@reduxjs/toolkit'
interface Notification {
    _id: string;
    message: string;
    type: string;
    isRead: boolean;
    timestamp: Date;
    color: string;
}
export interface NotificationState {
    notifications: {
        read: Notification[],
        unread: Notification[]
    }
}

const initialState: NotificationState = {
    notifications: {
        read: [],
        unread: []
    }
};

const desktopNotificationSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        updateNotifications: (state: NotificationState, action: PayloadAction<NotificationState>) => {
            state.notifications = action.payload.notifications;
        },
    },
});

export const { updateNotifications } = desktopNotificationSlice.actions;
export default desktopNotificationSlice.reducer;
